export default __webpack_public_path__ + "static/media/lacrosse-mockup.675e060f.png";